import { Entity, LiveData } from '@toeverything/infra';
import { map } from 'rxjs';

import type { FolderStore } from '../stores/folder';
import { FolderNode } from './folder-node';

export class FolderTree extends Entity {
  constructor(private readonly folderStore: FolderStore) {
    super();
  }

  readonly rootFolder = this.framework.createEntity(FolderNode, {
    id: null,
  });

  isLoading$ = this.folderStore.watchIsLoading();

  // get folder by id
  folderNode$(id: string) {
    return LiveData.from(
      this.folderStore.watchNodeInfo(id).pipe(
        map(info => {
          if (!info) {
            return null;
          }
          return this.framework.createEntity(FolderNode, {
            id,
          });
        })
      ),
      null
    );
  }

  // get first node that links to a specific docId
  folderNodeByDocId$(docId: string) {
    return LiveData.from(
      this.folderStore.watchNodesByData('doc', docId).pipe(
        map(list => {
          const first = list?.[0];
          if (!first) return null;
          return this.framework.createEntity(FolderNode, { id: first.id });
        })
      ),
      null
    );
  }
}
